
/* injects from baggage-loader */

angular.module('siter.io').controller('NewLessonSectionModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Section", "$window", "FileUploader", "allLessonSections",
  ($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, FileUploader, allLessonSections) => {
    var setUploadUrls;

    $scope.close = () => {
      $modalInstance.dismiss("close");
    };

    $scope.loadTags = (query) => {
      return Restangular.all("/sections/tags?q=" + query + "&for_email=true").getList();
    };

    $scope.loadColorTags = (query) => {
      return Restangular.all("/sections/color_tags?q=" + query + "&for_email=true").getList();
    };

    $scope.section = {disabled: true};
    $scope.sectionPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/lms_page_templates/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });

    $scope.sectionPreviewUploader.onAfterAddingFile = (item) => {
      const ref = item.file.type;
      const types = ["image/jpeg", "image/png"];
      if (types.indexOf(ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };

    $scope.sectionPreviewUploader.onSuccessItem = (fileItem, response, status, headers) => {
      $scope.sectionPreviewUploader.clearQueue();
    };

    $scope.sectionPreviewUploader.onErrorItem = (fileItem, response, status, headers) => {
      console.error({fileItem, response, status, headers});
    };

    setUploadUrls = (sectionId) => {
      $scope.sectionPreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/sections/" + sectionId);
      });
    };

    $scope.create = (createSectionForm, section) => {
      if (createSectionForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      section.tags = _.map(section.tags, (tag) => {
        return tag.name;
      });
      section.tags = section.tags.join(",");
      section.colors = _.map(section.colors, (tag) => {
        return tag.text;
      });
      section.for_lms_page = true;
      Section.createPublic(section).then((sectionData) => {
        setUploadUrls(sectionData.id);
        $scope.sectionPreviewUploader.uploadAll();
        $scope.close();
        $scope.creating = false;
        allLessonSections.push(sectionData);
      }, function() {
        return $scope.creating = false;
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/lesson/newLessonSection.controller.js